import React from 'react';

const DefaultContent: React.FC = () => (
    <span>Request proof of work was added</span>
);

export default DefaultContent;
